import "./style.css";
import { screenIs } from "./screenIs.js";
import isInViewport from "./isInViewport.js";
import justinTextureUrl from "./justin2.jpg";
import spaceTextureUrl from "./grid.jpg";
import moonTextureUrl from "./moon.jpg";
import normalMapUrl from "./normal.jpg";

import * as THREE from "three";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import pixelsLeftToScroll from "./pixelsLeftToScroll.js";

const firstQuote = document.getElementById("firstQuote");
const secondQuote = document.getElementById("secondQuote");

// Set up scene
const scene = new THREE.Scene();
const fragment = document.querySelector("#fragment").textContent;

const vertex = document.querySelector("#vertex").textContent;
const camera = new THREE.PerspectiveCamera(
  75,
  window.innerWidth / window.innerHeight,
  0.1,
  1000,
);

const renderer = new THREE.WebGLRenderer({
  canvas: document.querySelector("#bg"),
});

renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);

camera.position.setZ(30);
camera.position.setX(-3);

renderer.render(scene, camera);

// Torus

const geometry = new THREE.TorusGeometry(10, 3, 16, 100);
const material = new THREE.MeshStandardMaterial({ color: "white" });
material.wireframe = true;
material.wireframeLinewidth = 2117;
const torus = new THREE.Mesh(geometry, material);
torus.rotateX(0.5);
scene.add(torus);

// Light sources
const pointLight = new THREE.PointLight(0xeeeeee);
pointLight.position.set(5, 5, 5);

const ambientLight = new THREE.AmbientLight(0xdddddd);
scene.add(pointLight, ambientLight);

function getShadeOfColor(t, startColor = 0xffffff, endColor = 0x00008b) {
  // Ensure t is clamped between 0 and 1
  t = Math.max(0, Math.min(1, t));

  // Define start (white) and end (dark blue) colors
  startColor = new THREE.Color(startColor); // white
  endColor = new THREE.Color(endColor); // dark blue

  // Create a new color for the result
  const resultColor = new THREE.Color();

  // Interpolate between startColor and endColor by factor t
  // and set resultColor to the interpolated color
  resultColor.lerpColors(startColor, endColor, t);

  return resultColor;
}

function addStar() {
  const alternateColorSeed = Math.random();
  const geometry = new THREE.SphereGeometry(0.08, 24, 24);
  const material = new THREE.MeshStandardMaterial({
    color:
      alternateColorSeed > 0.5
        ? getShadeOfColor(Math.random())
        : getShadeOfColor(Math.random(), 0xff0000, 0xffffff),
  });
  const star = new THREE.Mesh(geometry, material);

  const [x, y, z] = Array(3)
    .fill()
    .map(() => THREE.MathUtils.randFloatSpread(100));

  star.position.set(x, y, z);
  scene.add(star);
}

Array(200).fill().forEach(addStar);

// Background
// Plane Material
const planeMat = new THREE.ShaderMaterial({
  side: THREE.DoubleSide,
  uniforms: {
    u_hue: { type: "f", value: 0 },
    u_time: { type: "f", value: 0 },
    u_resolution: { type: "v4", value: new THREE.Vector4() },
    u_strength: { type: "f", value: 0 },
    u_speed: { type: "f", value: 0 },
    u_texture: {
      type: "t",
      value: new THREE.TextureLoader().load(spaceTextureUrl),
    },
    u_distortion: { type: "i", value: 1 },
  },
  // wireframe: true,
  transparent: true,
  vertexShader: vertex,
  fragmentShader: fragment,
});

// Plane Geometry
const planeGeo = new THREE.PlaneGeometry(1, 1, 100, 100);

// Plane Mesh
const plane = new THREE.Mesh(planeGeo, planeMat);

// Add plane to scene and bind to camera
camera.add(plane);
plane.scale.set(1900, 1500, 100);
plane.position.set(0, 0, -700);
scene.add(camera);

// Justin
const justinTexture = new THREE.TextureLoader().load(justinTextureUrl);
justinTexture.colorSpace = THREE.SRGBColorSpace;
const justin = new THREE.Mesh(
  new THREE.BoxGeometry(3, 3, 3),
  new THREE.MeshBasicMaterial({ map: justinTexture }),
);
scene.add(justin);

// Glasses
const loader = new GLTFLoader();
let glasses;
loader.load(
  "./scene.gltf", // or .gltf
  function (gltf) {
    glasses = gltf.scene;
    // gltf.scene.rotateY(120);
    // gltf.scene.rotateZ(180);
    // gltf.scene.rotateX(120);
    gltf.scene.position.setZ(0);
    gltf.scene.position.setX(-100);
    gltf.scene.scale.set(200, 200, 200);
    scene.add(gltf.scene);
  },
  undefined, // We are not using the onProgress callback
  function (error) {
    console.error("An error happened", error);
  },
);

function positionHeader() {
  const header = document.querySelector("header");
  header.classList.remove("-translate-x-full");
}

// Position Justin on load and resize
function positionJustin() {
  if (screenIs("md")) {
    justin.scale.set(1, 1, 1);
    justin.position.x = 2;
  } else {
    justin.scale.set(0.7, 0.7, 0.7);
    justin.position.x = -0.1;
    justin.position.y = 0;
  }
  justin.position.z = -4;
}

function positionQuotes() {
  if (!screenIs("sm")) {
    // this one runs when the screen height is less than 640px
    firstQuote.style.position = "fixed";
    firstQuote.style.bottom = 0 + "px";
    secondQuote.style.marginTop = "24rem";
  } else {
    // this runs when screen height is more than 640px
    firstQuote.style.position = "static";
    firstQuote.style.bottom = "0";
    secondQuote.style.marginTop = window.innerHeight * 0.7 + "px";
  }
}

// scroll animation
function moveCamera() {
  const t = document.body.getBoundingClientRect().top;
  const pixelsLeft = pixelsLeftToScroll();
  const threshold = window.innerHeight * 0.5;

  const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a));
  const invlerp = (x, y, a) => clamp((a - x) / (y - x));

  justin.rotation.y += 0.01;
  justin.rotation.z += 0.01;

  camera.position.z = t * -0.01;
  camera.position.x = t * -0.0002;
  camera.rotation.y = t * -0.0002;

  let newPosition;
  if (glasses) {
    if (pixelsLeft < threshold) {
      // here we move the glasses in a direction that is moving away from the camera
      // find out the vector from the glasses to the camera
      // move the glasses in the opposite direction
      const range = invlerp(0, threshold, pixelsLeft);

      const direction = glasses.position.clone().sub(camera.position);
      direction.normalize();
      direction.multiplyScalar(5);
      newPosition = glasses.position.clone().add(direction);
      glasses.position.copy(newPosition);
    } else {
      glasses.rotation.z = t * 0.0018;
      glasses.rotation.x = t * 0.00013;
      glasses.rotation.y = t * 0.0002;
      glasses.position.z = t * -0.002;
      glasses.position.y = t * -0.0009;
      glasses.scale.set(t * 0.2, t * 0.2, t * 0.2);
    }
  }
}

document.body.onresize = () => {
  renderer.setSize(window.innerWidth, window.innerHeight);
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  planeMat.uniforms.u_resolution.value.x = window.innerWidth;
  planeMat.uniforms.u_resolution.value.y = window.innerHeight;
  positionJustin();
  positionQuotes();
};

document.body.onscroll = () => {
  if (isInViewport(secondQuote, "orAbove")) {
    firstQuote.classList.add("scale-0");
    firstQuote.classList.remove("scale-100");
  } else {
    firstQuote.classList.remove("scale-0");
    firstQuote.classList.add("scale-100");
  }

  firstQuote.style.filter = `hue-rotate(${Math.min(window.scrollY * 0.41, 360)}deg) `;
  moveCamera();
};

// Animation Loop

function animate() {
  requestAnimationFrame(animate);

  torus.rotation.x += 0.001;
  torus.rotation.y += 0.0005;
  torus.rotation.z += 0.001;

  // moon.rotation.x += 0.005;

  // Update Uniforms
  planeMat.uniforms.u_time.value += 0.05;
  planeMat.uniforms.u_distortion.value = 5;
  planeMat.uniforms.u_strength.value = 15.0;
  planeMat.uniforms.u_speed.value = 0.5;

  planeMat.uniforms.u_hue.value += 0.0005;

  // ontrols.update();
  // composer.render();
  renderer.render(scene, camera);
}

// Scroll Animation
moveCamera();
positionJustin();
positionQuotes();
animate();
positionHeader();
